import { isCNPJ, isCPF } from 'brazilian-values'

export default {
	cpf: [(value) => isCPF(value) || 'CPF inválido'],
	cnpj: [(value) => isCNPJ(value) || 'CNPJ inválido'],
	email: [
		(value) => !!value || 'Campo requerido',
		(value) => /.+@.+/.test(value) || 'E-mail precisa ser válido',
	],
	password: [
		(value) => !!value || 'Campo requerido',
		(value) =>
			(value !== undefined && value.length >= 6) ||
			'Senha deve ter no mínimo 6 caracteres',
	],
	domain: [
		(value) => !!value || 'Campo requerido',
		(value) =>
			(value && ((value.includes('.com') || value.includes('.store') ) || !value.includes('.'))) ||
			'Site/URL inválida',
		(value) =>
			(value && value.includes('https://')) ||
			'Link inválido',
	],
	shortLink: [
		(value) => !!value || 'Campo requerido',
		(value) =>
			(value && value.includes('http://magafilio.com.br/api/')) ||
			(value && value.includes('https://magafilio.com.br/api/')) ||
			'Site/URL inválida',
	],
	img_logo: [
		(value) => !!value || 'Campo requerido',
		(value) =>
			(value && value.includes('.png')) ||
			(value && value.includes('.svg')) ||
			'Link/URL inválida',
		(value) =>
			(value && value.includes('http://')) ||
			(value && value.includes('https://')) ||
			'Site/URL inválida',
	],
	required: [
		(value) => {
			if (Array.isArray(value)) {
				return !!value.length || 'Campo Requerido'
			}
			return !!value || 'Campo requerido'
		},
	],
	isObjectId: function (value) {
		return new RegExp('^[0-9a-fA-F]{24}$').test(value)
	},
	number: [
		(value) => !!value || 'Campo requerido',
		(value) => !isNaN(value * 1) || 'Precisa ser um número decimal',
	],
	isCpf: (value) => isCPF(value),
	isCnpj: (value) => isCNPJ(value),
	isValidDate: [(value) => {

		if(value !== undefined && value !== '') {
			const dataNow = new Date()

			const data = value.split('/')

			const [dia, mes, ano] = data

			const day = parseInt(dia)
			const month = parseInt(mes)
			const year = parseInt(ano)

			if ( (day > 0 && day <= 31) && (month > 0 && month <= 12) && (year > 1900 && year < dataNow.getFullYear()) ) {
				return true
			}

			return 'Data inválida'
		} else {
			return 'Campo requerido'
		}
	}],
	validarPIS: [(value) => {
		var multiplicadorBase = '3298765432'
		var total = 0
		var resto = 0
		var multiplicando = 0
		var multiplicador = 0
		var digito = 99

		if(value !== undefined && value !== '') {
		// Retira a mascara
			var numeroPIS = value.replace(/[^\d]+/g, '')

			if (numeroPIS.length !== 11 ||
				numeroPIS === '00000000000' ||
				numeroPIS === '11111111111' ||
				numeroPIS === '22222222222' ||
				numeroPIS === '33333333333' ||
				numeroPIS === '44444444444' ||
				numeroPIS === '55555555555' ||
				numeroPIS === '66666666666' ||
				numeroPIS === '77777777777' ||
				numeroPIS === '88888888888' ||
				numeroPIS === '99999999999') {
				return 'PIS inválido'
			} else {
				for (var i = 0; i < 10; i++) {
					multiplicando = parseInt( numeroPIS.substring( i, i + 1 ) )
					multiplicador = parseInt( multiplicadorBase.substring( i, i + 1 ) )
					total += multiplicando * multiplicador
				}

				resto = 11 - total % 11
				resto = resto === 10 || resto === 11 ? 0 : resto
				digito = parseInt('' + numeroPIS.charAt(10))
				return resto === digito ? true : 'PIS inválido!'
			}
		} else {
			return 'Campo requerido'
		}
	}]
}
